// store/modalSlice.ts
import { modalMap } from '@/components/Common/Modals/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ModalDataState = {
  [K in keyof typeof modalMap]: {
    modalData: any;
    callback?: (data: any) => void;
    [key: string]: any;
  };
};

type ModalState = {
  activeModal: keyof typeof modalMap | null;
  modals: ModalDataState;
};

const initialData = () => {
  return (Object.keys(modalMap) as Array<keyof typeof modalMap>).reduce(
    (acc, key) => {
      acc[key] = {
        modalData: null,
      };
      return acc;
    },
    {} as ModalDataState
  );
};

const initialState: ModalState = {
  activeModal: null,
  modals: initialData(),
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (
      state,
      action: PayloadAction<{
        modalKey: keyof typeof modalMap;
        modalData?: any;
        callback?: (data: any) => void;
      }>
    ) => {
      state.activeModal = action.payload.modalKey;
      state.modals[action.payload.modalKey].modalData =
        action.payload.modalData || null;

      if (action.payload.callback)
        state.modals[action.payload.modalKey].callback =
          action.payload.callback;
    },
    hideModal: (state) => {
      state.activeModal = null;
      // state.modalData = null;
      // state.modals = initialData();
    },
    updateData: (
      state,
      action: PayloadAction<{
        key: string;
        value: any;
      }>
    ) => {
      state.modals[state.activeModal!][action.payload.key] =
        action.payload.value;
    },
  },
});

export const { showModal, hideModal, updateData } = modalSlice.actions;

export default modalSlice.reducer;
